import React from 'react'
import { map } from 'lodash'
import popup from '../../popup'
import './style.css'

import { removeDevice } from '../../../../redux/devices/helpers'

import PopupDevice from '../../../../components/PopupDevice'
import connect from "~/tools/connect";
import userStore from "~/redux/user/store"

class ManageDevices extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      devices: props.args.devices,
      deviceCount: props.args.devices.length,
      fields: props.args.fields
    }
    this.handleRemoveDevice = this.handleRemoveDevice.bind(this)
  }

  renderDevices() {
    if (this.state.deviceCount > 0 ) {
      return map(this.state.devices, device => {
        return <PopupDevice key={device.deviceId} device={ device } removeDevice={ this.handleRemoveDevice } fields={this.state.fields} />
      })
    } else {
      return <p>{this.state.fields.manageDevicesPopupMessage}</p>
    }
  }

  handleRemoveDevice(id) {
    removeDevice(id).then(response => {
      const updatedDevices = this.state.devices.filter(item => {return item.deviceId !== id})
      this.setState({
        devices: updatedDevices,
        deviceCount: this.state.deviceCount - 1
      })
      this.props.args.getDevices(this.props.user)
    }).catch(error => {
      console.log(error)
    })
  }
  
  render() {
    return (
      <div className="user-devices centered padded">
        <h3>{this.state.fields.manageDevicesPopupHead}</h3>
        <hr/>
        { this.renderDevices() }
        <div className="text-right">
          <div className="button outlined" onClick={ _ => { popup.hide() } }>{this.state.fields.manageDevicesPopupClose}</div>
        </div>
      </div>
    )
  }
}

connect(ManageDevices, (state) => ({ user: state.user }), userStore)

export default ManageDevices;